// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"31fb4c1c","796":"55872f3f"}[chunkId] + ".chunk.js";
};